/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Compare_DocumentsInputs */



/**
* | output |
* | --- |
* | "Compare two documents" |
*
* @param {Uno_Welcome_Suggestion_Compare_DocumentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_compare_documents = /** @type {((inputs?: Uno_Welcome_Suggestion_Compare_DocumentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Compare_DocumentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zwei Dokumente vergleichen")
	return /** @type {LocalizedString} */ ("Compare two documents")
});